export function normalizeWorkUnit(value:string|null|undefined):string {
 return (value ?? "").trim().toLocaleLowerCase("pt-PT").replaceAll("²","2").replaceAll("³","3");
}

export function initialCompatibleArticleId(
 articles:readonly {id:string;work_items:{unit:string}}[],
 targetUnit?:string|null,
):string|null{
 if(targetUnit==null)return articles[0]?.id ?? null;
 const unit=normalizeWorkUnit(targetUnit);
 if(!unit)return null;
 return articles.find(article=>normalizeWorkUnit(article.work_items.unit)===unit)?.id ?? null;
}
